import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  TextField,
} from '@mui/material'
import { Autocomplete } from '@mui/material';
import api from 'utils/api'
import * as businessActions from 'modules/Business/actions'

const KeywordsEditor = ({ businessId, keywords, onClose, }) => {
  const dispatch = useDispatch()
  const [posting, setPosting] = useState(false)
  const [newKeywords, setNewKeywords] = useState(keywords || [])
  const [inputValue, setInputValue] = useState('')
  const { enqueueSnackbar } = useSnackbar()

  const handleChange = useCallback(
    (val) => {
      setNewKeywords(val)
    },
    [setNewKeywords]
  )

  const handleInputChange = useCallback((event, value) => {
    setInputValue(value)
  }, [])

  const handleSubmit = useCallback(() => {
    const url = `/business/${businessId}/keywords`
    // Include any pending inputValue (text typed but not yet confirmed with Enter/comma)
    const pendingKeyword = inputValue.trim()
    const finalKeywords = pendingKeyword && !newKeywords.includes(pendingKeyword)
      ? [...newKeywords, pendingKeyword]
      : newKeywords
    setPosting(true)
    api
      .put(url, { keywords: finalKeywords })
      .then(() => {
        enqueueSnackbar('Saved keywords', { variant: 'success' })
        dispatch(businessActions.updateBusinessKeywords(finalKeywords))
        onClose()
      })
      .catch(() => {
        enqueueSnackbar('Cannot save your keywords', { variant: 'error' })
        setPosting(false)
      })
  }, [businessId, dispatch, enqueueSnackbar, inputValue, newKeywords, onClose])

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onClose} >
      <DialogTitle>Edit business keywords</DialogTitle>
      <DialogContent>
        <Autocomplete sx={{mt: 1}}
          ChipProps={{ color: 'primary' }}
          onChange={(e, val) => {
            handleChange(val)
          }}
          onInputChange={handleInputChange}
          inputValue={inputValue}
          options={[]}
          freeSolo
          size="small"
          name="keywords"
          multiple
          value={newKeywords || []}
          renderInput={params => (
            <TextField
              {...params}
              fullWidth
              InputLabelProps={{
                color: 'primary',
              }}
              label="Keywords"
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === ',') {
                  e.preventDefault()
                  const newValue = e.target.value.trim()
                  if (newValue) {
                    handleChange([...(newKeywords || []), newValue])
                    setInputValue('')
                  }
                }
              }}
            />
          )}
        />
          <FormHelperText>
              Type in a keyword, or words followed by ‘enter’ or ‘comma‘.
          </FormHelperText>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="flex-end">
          <Button color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            disabled={posting}
            variant="contained"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default KeywordsEditor